/**
 *
 * Asynchronously loads the component for AnimalCaseConsumablesPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AnimalCaseConsumablesPage = lazyLoad(
  () => import('./index'),
  module => module.AnimalCaseConsumablesPage,
);
